import request from '@/utils/request';

import { queryRight } from './workspace';

/**
 * 获取音色Tab列表
 * @returns
 */

export const getVoiceTabs = async () => {
  const res = await request('/api/rest/dlt/template/group', {
    method: 'POST',
    data: {
      model: 'timbre',
    },
  });
  return res;
};

/**
 * 删除音色
 * @param params
 * @returns
 */
export const deleteVoice = async (params: any) => {
  const res = await request('/api/rest/dhc/template/personal/del', {
    method: 'POST',
    data: params,
  });
  return res;
};

/**
 * 重命名音色
 * @param params
 * @returns
 */
export const updateVoice = async (params: any) => {
  const res = await request('/api/rest/dhc/template/personal/update', {
    method: 'POST',
    data: params,
  });
  return res;
};

/**
 * 已经用了的席位
 * @param data type：1数字人 2音色
 * @returns
 */
export const fetchUsedSeats = async (data: {}) => {
  const res = await request('/api/rest/dlt/template/personal/used', {
    method: 'POST',
    data,
  });
  return res;
};

/**
 * 查询数字人详情
 * @param data
 * @returns
 */
export const fetchAvatarDetail = async (data: {
  templateCodes: string;
}): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    const res = await request('/api/rest/dlt/template/detail/list', {
      method: 'POST',
      data,
    });
    if (res.isError) {
      reject(res);
    } else {
      resolve(res);
    }
  });
};

/**
 * 创建音色
 * @param data
 * @returns
 */
export const generateCustomVoice = async (data: {
  voiceUrl: string;
  title: string;
  gender: 1 | 2;
  voiceCloneType: 5 | 6;
  voicePreviewText: string;
}): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    const res = await request('/api/rest/dlt/cloud/voice/clone', {
      method: 'POST',
      data,
    });
    if (res.isError) {
      reject(res);
    } else {
      resolve(res);
    }
  });
};

/**
 * 获取音色列表的席位
 */
export const fetchVoiceSeats = async () => {
  const seat = {
    available: 0,
    total: 0,
    used: 0,
  };
  const getUsedSeats = () => fetchUsedSeats({ type: 2 });
  const getTotalSeats = () => queryRight();

  const res = await Promise.allSettled([getTotalSeats(), getUsedSeats()]);

  if (res[0].status === 'fulfilled') {
    const target = res[0].value.data.find((item: any) => item.key === 'maxToneClone');
    seat.total = target?.leftValue || 0;
  }
  if (res[1].status === 'fulfilled' && res[1].value.code === 200) {
    seat.used = res[1].value.data.count;
    seat.available = seat.total - res[1].value.data.count;
  }

  return seat;
};

// 声音克隆
export const createVoice = async (data: {
  voiceUrl: string;
  gender: number;
  voiceCloneType: number;
  voicePreviewText: string;
  needTemplate: boolean;
}): Promise<any> => {
  const res = await request('/api/rest/dlt/f/cloud/voice/clone', {
    method: 'POST',
    data,
  });
  return res;
};
